import "./About.scss";

import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ORGANIZATION } from "../../config/organization";
import ServicesType from "../../types/Service";

const About: React.FC = () => {
  const { t } = useTranslation();

  const servicesList = t("services.list", {
    returnObjects: true,
  }) as ServicesType[];

  return (
    <main className="aboutPage">
      <h1 className="pageTitle">{t("aboutPage.title")}</h1>
      <p className="officialStatement">{t("aboutPage.officialSite")}</p>

      <section className="pageSection">
        <h2 className="sectionTitle">{t("aboutPage.identityTitle")}</h2>
        <p className="sectionText">{t("aboutPage.identityText")}</p>
        <address className="identityCard">
          <strong>{ORGANIZATION.legalName}</strong>
          <span>{t("legalNotice.legalFormValue")}</span>
          <span>
            {t("legalNotice.companyNumberLabel")} : {ORGANIZATION.companyNumber}
          </span>
          <span>
            {ORGANIZATION.address.street}, {ORGANIZATION.address.postalCode}{" "}
            {ORGANIZATION.address.city}, {ORGANIZATION.address.country}
          </span>
          <a className="pageLink" href={`mailto:${ORGANIZATION.email}`}>
            {ORGANIZATION.email}
          </a>
        </address>
      </section>

      <section className="pageSection">
        <h2 className="sectionTitle">{t("aboutPage.missionTitle")}</h2>
        <p className="sectionText">{t("about.text")}</p>
      </section>

      <section className="pageSection">
        <h2 className="sectionTitle">{t("aboutPage.activitiesTitle")}</h2>
        <p className="sectionText">{t("aboutPage.activitiesIntro")}</p>
        <ul className="activitiesList">
          <li>{t("aboutPage.activitiesEvents")}</li>
          {servicesList?.map((service) => (
            <li key={service.name}>{service.name}</li>
          ))}
        </ul>
      </section>

      <section className="pageSection">
        <h2 className="sectionTitle">{t("aboutPage.legalTitle")}</h2>
        <p className="sectionText">{t("aboutPage.legalText")}</p>
        <p className="sectionText">
          <Link className="pageLink" to="/mentions-legales">
            {t("aboutPage.legalLink")}
          </Link>
        </p>
      </section>

      <section className="pageSection">
        <h2 className="sectionTitle">{t("aboutPage.contactTitle")}</h2>
        <p className="sectionText">{t("aboutPage.contactText")}</p>
        <p className="sectionText">
          <a className="pageLink" href={`mailto:${ORGANIZATION.email}`}>
            {ORGANIZATION.email}
          </a>
        </p>
      </section>
    </main>
  );
};

export default About;
